import React, { useState, useEffect } from 'react';

import { styled } from '@mui/material/styles';
import { Stack, Box, Typography, Collapse } from '@mui/material';
import Iconify from './Iconify';

const ExpandMore = styled((props) => {
  const { expand, ...other } = props;
  return (
    <Box
      sx={{
        width: '16px',
        height: '16px',
        border: '1px solid #DFE2E6',
        borderRadius: '100px',
        background: '#FAFAFA',
        ml: 1,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Iconify
        width={14}
        height={14}
        icon={'mdi:keyboard-arrow-down'}
        {...other}
      />
    </Box>
  );
})(({ theme, expand }) => ({
  transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  }),
}));

export default function ShowMoreCollapse({
  children,
  label = 'Más info',
  onChange = () => {},
}) {
  const [expanded, setExpanded] = useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  useEffect(() => {
    onChange(expanded);
  }, [expanded]);

  return (
    <>
      <Stack direction="row" alignItems="center" spacing={0}>
        <Box>
          <Typography
            sx={{ flex: 1, color: '#6E6E73' }}
            variant="caption2"
            component="div"
          >
            {label}
          </Typography>
        </Box>
        <Box>
          <ExpandMore
            expand={expanded}
            onClick={handleExpandClick}
            aria-expanded={expanded}
            aria-label="show more"
          />
        </Box>
      </Stack>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        {children}
      </Collapse>
    </>
  );
}
